import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedHttpService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(AuthService);
  private options() { return from(this.auth.acquireAccessToken()).pipe(switchMap(token => [{ headers: new HttpHeaders({ Authorization: `Bearer ${token}` }) }])); }
  get<T>(url: string): Observable<T> { return this.options().pipe(switchMap(options => this.http.get<T>(url, options))); }
  post<T>(url: string, body: unknown): Observable<T> { return this.options().pipe(switchMap(options => this.http.post<T>(url, body, options))); }
  delete<T>(url: string): Observable<T> { return this.options().pipe(switchMap(options => this.http.delete<T>(url, options))); }
}
